export { ModalService } from 'sce-ui-lib/components/modal/modal.service';
// #TODO-LIBRARY



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/modal.service.ts